const standsGlobalBasePath = '/stands-global';

export const GLOBAL_STANDS_FILTER_FIELDS = [
    'AQUISE_NUMBER',
    'PROAUF_NUMBER',
    'BLOCK',
    'CAD_NUMBER',
    'CORRIDOR',
    'STAND_NUMBER',
    'DELIVERY_TIME_AT'
];


const StandsGlobalConst = {
    basePath: standsGlobalBasePath,
};

export default StandsGlobalConst;
